import React from 'react';
import RenderChart from '@nile/reports/src/modules/reports/components/subpages/RenderChart';
import RGL, { WidthProvider } from 'react-grid-layout';
import nanoid from 'nanoid';
import { SizeMe } from 'react-sizeme';
import { DisplayText, TextStyle } from '@superops/ui-design-system';
import { NUMBER } from '@nile/reports/src/modules/charts/constants';
import { FormattedMessage } from 'react-intl';

const ResponsiveReactGridLayout = WidthProvider(RGL);

function SectionMeta({ layoutData, index, rowHeight = 30 }) {
  return (
    <div className="full-width mt-10" key={`c-${nanoid()}`}>
      <div className="full-height full-width">
        <ResponsiveReactGridLayout
          className={`layout layout_${index} h91`}
          layout={layoutData || []}
          rowHeight={rowHeight}
          cols={12}
          isDroppable={false}
          isDraggable={false}
          isResizable={false}
          compactType="vertical"
          preventCollision={false}
        >
          {layoutData.map((l, i) => (
            <div key={`eff-${l}-${i}`} data-grid={l}>
              {l?.chart?.defaultChartType !== NUMBER && (
                <div className="flex actr mb20">
                  <>
                    <div className="flex fcol gy5 f11">
                      <DisplayText element="h3" weight="SemiBold">
                        <FormattedMessage id={l?.chart?.name || ''} />
                      </DisplayText>
                      <TextStyle>
                        <FormattedMessage id={l?.chart?.description} />
                      </TextStyle>
                    </div>
                  </>
                </div>
              )}
              <SizeMe monitorHeight monitorWidth>
                {({ size }) => (
                  <div className="flex h91 full-width">
                    <RenderChart
                      item={l}
                      isNumberCard
                      isEfficiencyReport
                      size={{
                        height: size?.height,
                        width: size?.width
                      }}
                    />
                  </div>
                )}
              </SizeMe>
            </div>
          ))}
        </ResponsiveReactGridLayout>
      </div>
    </div>
  );
}

export default SectionMeta;
